export const MAX_FREE_ALGORITHMS = 50;